import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import TestHeader from '../components/header/header.component';
import {auth,createUserProfileDocument } from '../firebase/firebase.utils';
import {setCurrentUser } from '../redux/user/user.actions';
import {selectCurrentUser} from '../redux/user/user.selectors';
import TestExamComponent from '../components/test/test.exam.componet';
import TestLoginComponent from '../components/test/test.login.component';
import './TestPage.style.scss';


class TestPage extends React.Component {


unsubscribeFromAuth = null

componentDidMount(){
const {setCurrentUser}=this.props

  this.unsubscribeFromAuth = auth.onAuthStateChanged(async userAuth => {
    if (userAuth){
      const userRef = await createUserProfileDocument(userAuth);
      
      userRef.onSnapshot(snapShot =>{
   
      setCurrentUser({
          id:snapShot.id,
          ...snapShot.data()
        });
      });
    }
    
 setCurrentUser(userAuth);
    
    
  });

}

componentWillUnmount(){

  this.unsubscribeFromAuth();
}


  render(){

    return (
      <div  className="test-page"> 
         <TestHeader/> 
     <Switch>
       <Route exact path='/'  render={
       ()=>this.props.currentUser 
       ? (
        <TestExamComponent/>)
       :(<TestLoginComponent/>) 
       }
        />
 
       
     </Switch>
  
      </div>
    );
  }
  }

 const mapStateToProps=createStructuredSelector({
   currentUser:selectCurrentUser
   });


  const mapDispatchToProps = dispatch =>({
  setCurrentUser:user=> dispatch(setCurrentUser(user))
  });

export default connect(mapStateToProps,mapDispatchToProps)(TestPage);